<mat-form-field class="full-width-form" color="accent">
	<mat-label>
		<mat-icon fontIcon="fa-clock" fontSet="fad" />
		{{ labelKey | translate }}
	</mat-label>
	<button (click)="endTimepicker.open()" mat-icon-button matSuffix type="button">
		<mat-icon color="accent" fontIcon="fa-clock" fontSet="fad" />
	</button>
	<input (click)="$event.stopImmediatePropagation(); endTimepicker.open()" [formControl]="formCtrl" matInput readonly />
	<ngx-material-timepicker
		#endTimepicker
		(timeSet)="onTimeChanged($event)"
		[defaultTime]="timeService.getTimeFormat() === 12 ? '12:00 PM' : '12:00'"
		[format]="timeService.getTimeFormat()"
		[minutesGap]="5"
		[theme]="theme === 'light' ? lightTheme : darkTheme"
		[min]="min()"
		[max]="max()"
	/>
	<mat-error>{{ T.ERROR_REQUIRED | translate }}</mat-error>
</mat-form-field>
